import classnames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { PermissionEnum } from '@creditsights/api-ui-web';
import useFetchUserPermissions from '../../../hooks/permissions/useFetchUserPermissions';
import styles from './LanguageSwitcher.module.scss';

const LanguageSwitcher = (): React.ReactElement | null => {
  const { data: userPermissions } = useFetchUserPermissions();
  const [ready, setReady] = useState(false);
  const [isOptionsShown, setIsOptionsShown] = useState(false);
  // const [, invalidate] = useState(false);
  const isAvailable = useMemo(() => userPermissions?.includes(PermissionEnum.TRANSLATION), [userPermissions]);
  const globalAny: any = global;

  useEffect(() => {
    const callback = () => {
      if (isAvailable === false) {
        globalAny.Weglot.switchTo(globalAny.Weglot.options.language_from);
      }
    };

    if (globalAny.Weglot) {
      globalAny.Weglot.on('languageChanged', callback);
    }

    return () => {
      if (globalAny.Weglot) {
        globalAny.Weglot.off('languageChanged', callback);
      }
    };
  }, [isAvailable]);

  useEffect(() => {
    const alreadyInitialized = !!globalAny.Weglot?.initialized;

    const callback = () => {
      setReady(true);
    };

    if (!alreadyInitialized) {
      globalAny.Weglot?.on('initialized', callback);
    } else {
      callback();
    }

    return () => {
      if (!alreadyInitialized) {
        globalAny.Weglot?.off('initialized', callback);
      }
    };
  }, [globalAny.Weglot?.initialized]);

  if (!globalAny.Weglot || !ready || !isAvailable) {
    return null;
  }

  const initialLang = globalAny.Weglot.options.language_from;
  const currentLang = globalAny.Weglot.getCurrentLang();

  const availableLanguages = [initialLang, ...globalAny.Weglot.options.languages.map((lang) => lang.language_to)];

  return (
    <div className={styles.body}>
      <div className={classnames(styles.options, { [styles.visible]: isOptionsShown })}>
        {availableLanguages.map((lang) => (
          <div
            key={lang}
            onClick={() => {
              globalAny.Weglot.switchTo(lang);
              setIsOptionsShown(false);
            }}
          >
            {globalAny.Weglot.getLanguageName(lang)}
          </div>
        ))}
      </div>
      <div className={styles.button} onClick={() => setIsOptionsShown(!isOptionsShown)}>
        {globalAny.Weglot.getLanguageName(currentLang)}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
